import {Card, Input, Space} from "antd";
import Explainer from "../../../components/Explainer";
import {Button, ButtonGroup} from "@mui/material";
import React, {useState} from "react";


const EtfSearch = ({filters, addTickerToSearch, removeTickerFromSearch, clearTickersFromSearch})=>{
    const [searchInput, setSearchInput] = useState(''); // State for search input

    const handleSearchChange = (e) => {
        setSearchInput(e.target.value);
    };

    const handleSearchSubmit = () => {
        if (searchInput) {
            addTickerToSearch(searchInput); // Call the function to add the ticker
            setSearchInput(''); // Clear the input field after adding
        }
    };

    return (
        <Card bordered={false} title={<Explainer title={'Stock Search'} tooltip={'Search for stocks across all the ETFs '}/>}
        >
                <Space direction={'vertical'}>
                    <Input
                        value={searchInput}
                        onChange={handleSearchChange}
                        placeholder="Enter ticker"
                        onPressEnter={handleSearchSubmit} // Add ticker on Enter
                    />
                    <ButtonGroup>
                        <Button variant={'text'} onClick={handleSearchSubmit} type="primary">Add</Button>
                        <Button variant={'text'} onClick={clearTickersFromSearch} type="danger">Clear</Button>
                    </ButtonGroup>
                </Space>
                <ul className={'py-3'}>
                        {filters.search.map(ticker => (
                            <li key={ticker}>
                                {ticker.toUpperCase()}
                                <Button onClick={() => removeTickerFromSearch(ticker)} color={'error'} size={'small'}>
                                    Remove
                                </Button>
                            </li>
                        ))}
                </ul>
        </Card>
    )
}

export default EtfSearch;